import Carousel from "react-bootstrap/Carousel";
import "./carousel.css";

export default Carousel;
